var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    'ord-row',
    _vm.darkRow ? 'dark' : null,
  ]},[_c('div',{staticClass:"ao-table-body"},[_c('div',{class:['grid-item js-s', _vm.bold ? 'sac__font-14 bold' : '']},[_vm._v(" "+_vm._s(_vm.name)+" ")]),_c('div',{staticClass:"grid-item js-c"},[_vm._v(" "+_vm._s(_vm.quantity)+" ")]),_c('div',{staticClass:"grid-item js-e"},[_vm._v(" "+_vm._s(_vm.total)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }